import { mapGetters, mapState } from "vuex";

export default {
  computed: {
    ...mapState("clients", ["salesPersonList"])
  },
  methods: {
    FilterStatsNonActiveUsers(arr) {
      if (arr) {
        return arr.filter(user => user.stats_active !== 0);
      }
      return this.salesPersonList.filter(user => user.stats_active !== 0);
    }
  }
};
